export default Object.freeze({
  CreditCard: 1,
  ManualBilling: 2,
});
